module.exports = __webpack_public_path__ + "img/contact-detail.f07f93a2.svg";